<div class="case-manager-header">
  <div class="main-page-heading">
    Teams
  </div>
</div>
<div class="case-manager-container">
  <div class="case-manager-inner-container">
    <manage-teams-table
      [data]="teams"
      [searchableFields]="searchableFields"
      [displayedColumns]="displayedColumns"
      [showClientFilter]="hasMultipleClients"
      [addRecordAction]="addRecordAction"
      (teamCreated)="reloadTeams($event)"
      initialSort="name"
      mode="manage-table"
    >
    </manage-teams-table>
  </div>
</div>
<router-outlet></router-outlet>